import { render, staticRenderFns } from "./form-installment2.vue?vue&type=template&id=fea8a2c0&"
import script from "./form-installment2.vue?vue&type=script&lang=js&"
export * from "./form-installment2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormCreditCalculator: require('/var/www/components/form/form-components/form-credit-calculator.vue').default,CarSlider3: require('/var/www/components/car/car-slider3.vue').default,CarTechMini: require('/var/www/components/car/car-tech-mini.vue').default,InputsInput: require('/var/www/components/inputs/input.vue').default,CheckboxGroup: require('/var/www/components/checkbox/checkbox-group.vue').default})
